var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 262,
    height: 86,
    viewBox: "0 0 272 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2651",
    "data-name": "Ret\\xE2ngulo 2651",
    width: 42,
    height: 42,
    transform: "translate(337 1654)",
    fill: "#55a695"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Prancheta_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 86
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prancheta_2",
    "data-name": "Prancheta \\u2013 2",
    clipPath: "url(#clip-Prancheta_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2650",
    "data-name": "Ret\\xE2ngulo 2650",
    width: 272,
    height: 86,
    rx: 5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_401",
    "data-name": "Grupo de m\\xE1scara 401",
    transform: "translate(-304 -1634)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "google-play",
    d: "M4.569,42.4V6.152A3.191,3.191,0,0,1,6.359,3.274l21,21-21,21A3.215,3.215,0,0,1,4.569,42.4m29.443-11.47L11.071,44.187l18.1-18.1,4.84,4.84m7.142-9.189a3.242,3.242,0,0,1,1.258,2.537A3.133,3.133,0,0,1,41.2,26.79L36.314,29.6l-5.33-5.33,5.33-5.33,4.84,2.793M11.071,4.361l22.94,13.261-4.84,4.84Z",
    transform: "translate(334.51 1650.726)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Dispon\\xEDvel_na_Google_Play",
    "data-name": "Dispon\\xEDvel na Google Play",
    transform: "translate(90 35)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dispon\xEDvel na"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 28
  }, "Google Play"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBlack);
export default __webpack_public_path__ + "static/media/google_playBlack.d9f529ee52877c8ab13342cbc8807539.svg";
export { ForwardRef as ReactComponent };